import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  startWebSocket: ['brand', 'department', 'webSocketUrl'],
  stopWebSocket: ['options'],
  resetWebSocket: [],
  reconnectWebSocket: ['brand', 'department', 'webSocketUrl'],
  handleWebSocketClose: ['event'],

  socketConnectAttempt: [],
  socketConnectSuccess: [],
  socketConnectFailure: ['error'],
  socketErrorNotification: ['error'],
  banUser: [],

  setPingResponse: ['responded'],
  setPingResponseError: ['error'],
  setIsReconnecting: ['reconnect'],

  /* Outbound Socket Events */
  sendNewChatRequest: ['brand', 'department'],
  sendPing: [],
  sendSocketMessage: ['message'],
  sendRenewChatRequest: ['chatId', 'authenticationKey'],

  /* Inbound Socket events */
  acknowledgment: ['result'],
  pong: [],
  newChatResponse: ['result'],
  newParticipant: ['result'],
  newMessage: ['result'],
  newStage: ['result'],
  endStage: ['result'],
  isTyping: ['result'],
  participantLeave: ['result'],
  wait: ['result'],
  newQuestion: ['result'],
  error: ['result'],
  endChat: ['result'],
})
